import { requestAdminJson } from './http'
import { asString, normalizeReleaseStatusPayload } from './release.normalizers'
import type {
  AdminManifestMetadata,
  AdminReleaseAlignmentSummary,
  AdminReleaseArtifactStatus,
  AdminReleaseNotesPayload,
  AdminReleaseServiceRollout,
  AdminReleaseStatusPayload,
} from './release.types'

export type {
  AdminManifestMetadata,
  AdminReleaseAlignmentSummary,
  AdminReleaseArtifactStatus,
  AdminReleaseNotesPayload,
  AdminReleaseServiceRollout,
  AdminReleaseStatusPayload,
}

export const fetchAdminReleaseNotes = async (
  token: string,
): Promise<AdminReleaseNotesPayload> => {
  const payload = await requestAdminJson({
    token,
    path: '/admin/release/notes',
    fallbackError: 'Impossibile caricare le note di rilascio',
  })

  return {
    current: asString(payload.current).trim(),
    previous: asString(payload.previous).trim(),
    notes: asString(payload.notes),
  }
}

export const fetchAdminReleaseStatus = async (
  token: string,
): Promise<AdminReleaseStatusPayload> => {
  const payload = await requestAdminJson({
    token,
    path: '/admin/release/status',
    fallbackError: 'Impossibile caricare lo stato release',
  })

  return normalizeReleaseStatusPayload(payload)
}
